/* @flow */
import { getterFromKeyPath } from 'trustar/utils';

export const loading = getterFromKeyPath(['notificationPreferences', 'loading']);
export const notificationPreferences = getterFromKeyPath(['notificationPreferences', 'notificationPreferences']);
export const activity = getterFromKeyPath(['notificationPreferences', 'settings', 'activity']);
export const activitySummary = getterFromKeyPath(['notificationPreferences', 'settings', 'activitySummary']);
export const watchedKeywords = getterFromKeyPath(['notificationPreferences', 'watchedKeywords']);
export const watchedKeywordsLoading= getterFromKeyPath(['notificationPreferences', 'watchedKeywordsLoading']);

export const globalEmailEnabled = getterFromKeyPath(['notificationPreferences', 'notificationPreferences', 'activity', 'global', 'emailEnabled']);
export const newReportEmailEnabled = getterFromKeyPath(['notificationPreferences', 'notificationPreferences', 'activity', 'newReport', 'emailEnabled']);
export const dailySummaryEnabled = getterFromKeyPath(['notificationPreferences', 'notificationPreferences', 'activitySummary', 'dailyEnabled']);
export const weeklySummaryEnabled = getterFromKeyPath(['notificationPreferences', 'notificationPreferences', 'activitySummary', 'weeklyEnabled']);


// WEBPACK FOOTER //
// ./src/app/modules/notificationPreferences/getters.js